import {
  DtoBase,
  TenantEnums,
  TenantModels,
} from '@project44-models/iam-gateway';

import { QueryHandler } from '../../../shared/domain/UseCase';
import { TUnifiedRoleCollectionDto } from '../../../UnifiedRoles/domain/interfaces';
import {
  IAllTenantAgnosticUnifiedRolesQuery,
  ISpecificTenantQueryUseCase,
  ITenantUnifiedRolesQuery,
} from '../interfaces';

export abstract class AllTenantAgnosticUnifiedRolesQueryUserCase
  extends QueryHandler<
    void,
    { allTenantAgnosticUnifiedRoles: TUnifiedRoleCollectionDto }
  >
  implements IAllTenantAgnosticUnifiedRolesQuery
{
  public readonly requiredAllOfPermissions = [];

  public readonly requiredAnyOfPermissions = [
    'system-admin:read:tenant-agnostic-user-role-assignments',
  ];
}

export abstract class TenantUnifiedRolesQueryUseCase
  extends QueryHandler<
    { tenant: DtoBase<TenantModels.TenantViewModel> },
    { tenantUnifiedRoles: TUnifiedRoleCollectionDto }
  >
  implements ITenantUnifiedRolesQuery
{
  public readonly requiredAllOfPermissions = [];

  public readonly requiredAnyOfPermissions = [
    'system-admin:read:tenant-specific-user-role-assignments',
  ];
}

export abstract class SpecificTenantQueryUseCase
  extends QueryHandler<
    {
      tenantStatus: TenantEnums.TenantStatusEnum;
      tenantUuid: string;
    },
    { tenant: DtoBase<TenantModels.TenantViewModel> }
  >
  implements ISpecificTenantQueryUseCase
{
  public readonly requiredAllOfPermissions = [];

  public readonly requiredAnyOfPermissions = ['system-admin:read:tenants'];
}
